import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-gdo-subscription-create-pin',
    templateUrl: './gdo-subscription-create-pin.component.html',
    styleUrls: ['./gdo-subscription-create-pin.component.scss'],
    standalone: false
})
export class GdoSubscriptionCreatePinComponent implements OnInit {
  @Input() type!: string;
  @Input() subsForm!: UntypedFormGroup;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  createPinSubmitted() {
    const pinDetails = this.subsForm.get('pinDetails');
    const newPin = pinDetails?.get('newPin');
    const confirmPin = pinDetails?.get('confirmPin');
    newPin?.markAsTouched();
    newPin?.updateValueAndValidity();
    confirmPin?.markAsTouched();
    confirmPin?.updateValueAndValidity();
  }
  onCancel() {
    sessionState.setItem("planType", "notearlybird")
    if (this.type) {
      this.router.navigate(['/gdoWV'], { replaceUrl: true });
    } else {
      this.router.navigate(['/gdo-product'], { replaceUrl: true });
    }
  }
 
}
